import { AnchorButton } from "components/Button/AnchorButton";
import { IconMinus } from "components/Icons/IconMinus";
import { useState } from "react";
import { Faq, faqs } from "./content/faqs";
import styles from "./Faqs.module.css";
import cn from "classnames";
import { IconPlus } from "components/Icons/IconPlus";
import pageStyles from "./PricingPage.module.css";

export function Faqs() {
  return (
    <div className={cn(styles.container, pageStyles.sectionCentered)} id="faqs">
      <h1>
        Everything you need to know about <br /> Dune's subscription and how it
        works. <br /> Can't find an answer?
      </h1>
      <AnchorButton
        size="M"
        theme="tertiary"
        href="mailto:sales@dune.com"
        className={styles.button}
      >
        Reach out to us
      </AnchorButton>

      {faqs.map((faq, index) => (
        <div key={index} className={styles.faqs}>
          <h2>{faq.category}</h2>
          <ul>
            {faq.items.map((item, index) => (
              <FaqItem
                key={index}
                question={item.question}
                answer={item.answer}
                // Give a unique id to each question, with the category name as prefix
                // it will look like this `question-General_Questions-1`
                // This cannot be random as it is used to generate the anchor link
                id={`${faq.category.replace(/\s+/g, "_")}-${index}`}
              />
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

const FaqItem = ({
  question,
  answer,
  id,
}: Pick<Faq["items"][number], "question" | "answer"> & { id: string }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <li className={styles.faq} id={`question-${id}`}>
      <button
        tabIndex={0}
        className={styles.header}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className={cn(styles.question, isOpen && styles.openQuestion)}>
          {question}
          {isOpen ? <IconMinus /> : <IconPlus />}
        </div>
      </button>
      {isOpen && <div className={cn(styles.answer)}>{answer}</div>}
    </li>
  );
};
